const DISABLED_ATTR = "data-pr-disabled";

export function decorateAiSummary(scope: Document, disclaimer: string): void {
	const container = scope.querySelector<HTMLElement>(
		".pr-ai-summary__container"
	);
	if (!container) return;

	const footer = container.querySelector<HTMLElement>(
		".pr-ai-summary__footer"
	);
	if (!footer) return;

	const icon = container.querySelector<SVGElement>(
		".pr-ai-summary__heading-container .pr-icon-ai-star"
	);
	if (icon) {
		footer.insertBefore(icon, footer.firstChild);
	}

	const label = Array.from(footer.childNodes).find(
		(n) => n.nodeType === Node.TEXT_NODE
	);
	if (label) {
		if (label.textContent !== disclaimer) label.textContent = disclaimer;
	} else if (footer.textContent !== disclaimer) {
		footer.append(disclaimer);
	}
}

// `formatMarkup` must return trusted markup (our own translation + a number).
export function decorateReviewTotal(
	root: HTMLElement,
	formatMarkup: (count: number) => string
): void {
	const total = root.querySelector<HTMLElement>(".pr-rd-review-total");
	if (!total) return;

	const digits = total.textContent?.match(/\d[\d,]*/)?.[0];
	if (!digits) return;

	const count = Number.parseInt(digits.replace(/,/g, ""), 10);
	if (Number.isNaN(count)) return;

	const markup = formatMarkup(count);
	if (total.innerHTML !== markup) total.innerHTML = markup;
}

export function decoratePagination(
	root: HTMLElement,
	labels: { previous: string; next: string }
): void {
	const pagination = root.querySelector<HTMLElement>(".pr-rd-pagination");
	if (!pagination) return;

	const anchors = Array.from(
		pagination.querySelectorAll<HTMLAnchorElement>("a.pr-rd-pagination-btn")
	);
	const present = {
		next: anchors.some((a) => /next/i.test(a.className)),
		previous: anchors.some((a) => !/next/i.test(a.className))
	};

	for (const direction of ["previous", "next"] as const) {
		const stub = pagination.querySelector(
			`[${DISABLED_ATTR}="${direction}"]`
		);

		if (present[direction]) {
			stub?.remove();
			continue;
		}
		if (stub) continue;

		const button = document.createElement("button");
		button.type = "button";
		button.disabled = true;
		button.className = `pr-rd-pagination-btn pr-rd-pagination-btn--${direction}`;
		button.setAttribute(DISABLED_ATTR, direction);
		button.setAttribute("aria-label", labels[direction]);

		if (direction === "previous") {
			pagination.insertBefore(button, pagination.firstChild);
		} else {
			pagination.appendChild(button);
		}
	}
}
